<h2 *ngIf="data && data.title">{{ data.title }}</h2>
<mat-dialog-content *ngIf="data && data.body" [innerHTML]="data.body"></mat-dialog-content>
<div class="dialog-actions">
  <button type="button" class="button-primary button-confirm" (click)="dialogRef.close(true)" cdkFocusInitial
    translate>GENERAL.OK</button>
</div>